import { createThirdwebClient } from 'thirdweb';

// Get your free client ID at https://thirdweb.com/dashboard
// Then set REACT_APP_THIRDWEB_CLIENT_ID in your environment
export const client = createThirdwebClient({
  clientId: 'fcb132d642fa40f76126395f325cb25b',
});
